/*
 * Copyright (c) 2022-2022. Revo Digital
 * ---
 * Author: gabriele
 * File: RichTextTab.tsx
 * Project: mle-client-n
 * Committed last: 2022/2/9 @ 1742
 * ---
 * Description:
 */


import { observer }                     from 'mobx-react';
import {
  Editor
}                                       from '../../../../store/observables/Editor';
import { RichTextEditor }               from '../../editors/RichTextEditor';
import React, { useCallback, useState } from 'react';
import {
  ObservableRichText
}                                       from '../../../../store/observables/ObservableRichText';
import {
  RichTextEditorOverlay
}                                       from '../../../overlay/RichTextEditorOverlay';

interface Props {
  editor: Editor;
}

export const RichTextTab = observer((props: Props) => {
  const [ fullscreen, setFullscreen ] = useState(false);

  const enableFullscreen = useCallback(() => {
    setFullscreen(true);
  }, [ setFullscreen ]);

  const handleContentUpdate = useCallback((content: string) => {
    props.editor.getSelectedShape<ObservableRichText>().setHtmlContent(
      content,
      { applyToPamelaShape: true });
  }, []);

  const handleFullscreenExit = useCallback(() => {
    setFullscreen(false);
  }, [ setFullscreen ]);

  return (
    <div>
      <div className="bp4-text-muted mle-info-heading">
        Contenuto
      </div>
      <RichTextEditor
        editor={ props.editor }
        initialValue={ props.editor.getSelectedShape<ObservableRichText>().htmlContent }
        setter={ handleContentUpdate } disableExit={ true }
        actions={ [ {
          text: 'Passa a schermo intero',
          onClick: enableFullscreen,
          icon: 'fullscreen'
        } ] }
        mini
      />
      {
        fullscreen &&
        <RichTextEditorOverlay
          editor={ props.editor } isOpen={ fullscreen }
          onClose={ handleFullscreenExit }
          setter={ handleContentUpdate }
          initialValue={ props.editor.getSelectedShape<ObservableRichText>().htmlContent }
        />
      }
    </div>
  );
});
